import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const browseIssueRoute: InvariantJiraRoute = {
	name: 'issue',
	path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
	query: ['filter?!=(.*)', 'jql?!=(.*)'],
};
